import { css } from "@emotion/react";
import React from "react";
import PopUpWrapper from "@components/PopUpWrapper";
import theme from "@styles/theme";
import useAppSelector from "@hooks/useAppSelector";
import useAppDispatch from "@hooks/useAppDispatch";
import { showPopUp } from "@store/ui/uiSlice";
import { useTranslation } from "react-i18next";

interface EditRecurringIssueProps {
  onShowDeleteWindow: () => void;
}

const EditRecurringIssue: React.FC<EditRecurringIssueProps> = ({
  onShowDeleteWindow,
}) => {
  const { t } = useTranslation();
  const pos = useAppSelector(({ ui }) => ui.web.popUp?.pos);
  const dispatch = useAppDispatch();

  const onEdit = () => {
    dispatch(showPopUp({ type: "recurringIssue/new", pos: pos! }));
  };

  const onDelete = () => {
    onShowDeleteWindow();
  };

  return (
    <PopUpWrapper>
      <div>
        <div css={styles.task} onClick={onEdit}>
          {t("common.change")}
        </div>
        <hr />
        <div css={[styles.task, styles.onDelete]} onClick={onDelete}>
          {t("common.delete")}
        </div>
      </div>
    </PopUpWrapper>
  );
};

const styles = {
  task: css({
    width: "160px",
    paddingBottom: theme.sizing.scale200,
    fontSize: "17px",
    lineHeight: "20px",
    textAlign: "center",
    cursor: "pointer",
  }),
  onDelete: css({
    padding: `${theme.sizing.scale200} 0 0 0`,
    color: theme.colors.red,
  }),
};

export default EditRecurringIssue;
